<script>
import appConfig from "@/app.config";
import { http } from '@/helpers/easyindustriaapi/config';
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import List from "./list";
import Insert from "./insert";
import Edit from "./edit";

export default {
  page: {
    title: 'Plano de Contas',
    meta: [ {name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, List, Insert, Edit },
  data() {
    return {
      currentUser: {},
      currentEmpresa: {},
      currentPlanoConta: {},
      listPlanoContas: [],
      inserindo: false,
      editando: false,
      titleBody: 'Plano de Contas',
      items: [
        {
        text: "Dashboard",
        href: "/",
        },
        {
        text: "Cadastro",
        href: "/",
        active: true,
        },
        {
        text: "Convênio",
        href: "/acadastro/PlanoConta",
        active: true,
        }
      ],
    }
  },
  computed: {
    isHide() {
      return (!this.inserindo && !this.editando);
    },
  },
  created() {
    this.currentUser    = JSON.parse(localStorage.getItem('user'))
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
  },
  mounted() {
    this.getData();
  },
  methods: {
    makeToast(variant = null, message = 'Error generic') {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true,
        noAutoHide: true,
        html: true
      });
    },
    changeHomeTitle(newTitle) {
      this.titleBody = newTitle;
    },
    back() {
      this.inserindo = false;
      this.editando = false;
    },
    onLoader() {
      if (document.getElementById("preloader").style.display === "none")
      {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      }
    },
    offLoader() {
      if (document.getElementById("preloader").style.display === "block")
      {
        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      }
    },

    async getData() {
      this.onLoader()

      try {
        let response = await http.get('/plano-conta?empresa_id=' + this.currentEmpresa.id);

        if (response.status === 200) {
          this.listPlanoContas = response.data
          this.offLoader()
        }
      } catch (error) {
        let messageErro = error.response.data

        switch (error.response.status) {
          case 406:
            this.makeToast('danger', 'Erro 406: ' + messageErro)
            this.offLoader()
            break
          case 404:
            this.makeToast('danger', 'Erro 404: endpoint não encontrado ou servidor fora do ar')
            this.offLoader()
            break
        
          default:
            this.makeToast('danger', error.message)
            this.offLoader()
            break
        }
      }
    },

    insert () {
      this.inserindo = !this.inserindo;
    },
    edit(value) {
      this.currentPlanoConta = value;
      this.editando = !this.editando;
    },
    async doPost(planoConta) {
      planoConta.empresa_id = this.currentEmpresa.id;
      let response = await http.post('/plano-conta?empresa_id='+this.currentEmpresa.id, planoConta)
        .catch((error) => {
            this.makeToast('danger', error.response);
            this.offLoader();
        });

      if (response.status === 200) {
        this.getData();
        this.back();
        this.makeToast('success', 'Registro incluído');
      }
    },
    async doPut(planoConta) {
      this.onLoader();
      planoConta.user_id = this.currentUser.id;
      try {
        let response = await http.put('/plano-conta/'+planoConta.id+'?empresa_id='+this.currentEmpresa.id, planoConta);
        if (response.status === 200) {
          this.getData();
          this.back();
          this.makeToast('success', 'Registro alterado');
        }
      } catch (error) {
        this.offLoader();
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          const errorMessages = [];
          
          // Coleta todas as mensagens de erro
          for (const field in errorData) {
            if (Array.isArray(errorData[field])) {
              errorMessages.push(...errorData[field]);
            }
          }
          
          if (errorMessages.length > 0) {
            // Cria um toast para cada mensagem de erro
            errorMessages.forEach(message => {
              this.makeToast('danger', message);
            });
          } else {
            this.makeToast('danger', 'Erro ao alterar registro');
          }
        } else {
          this.makeToast('danger', 'Erro inesperado ao processar a requisição');
        }
      }
    },
    async doDelete(planoConta) {
      this.onLoader();
      planoConta.empresa_id = this.currentEmpresa.id;
      let response = await http.delete('/agreement/'+planoConta.id+'?empresa_id='+this.currentEmpresa.id, planoConta)
        .catch((error) => {
          this.offLoader();
            this.makeToast('danger', error.response);
        });

      if (response.status === 200) {
        this.getData();
        this.back();
        this.makeToast('warning', 'Registro excluído');
      }
    },
  },
}
</script>

<template>
<Layout>
  <PageHeader :title="titleBody" :items="items" />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <!-- Start Bar Buttons -->
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6 text-md-right">
              <button @click="insert()" v-if="isHide" type="button" class="btn btn-success">+ Incluir Convênio</button>
              <button @click="back()" v-if="!isHide" class="btn btn-secondary">Voltar</button>
            </div>
          </div>
        </div>
        <!-- End Bar Buttons -->
        <div class="card-body" v-if="!isHide">
          <Insert
           v-if="inserindo"
           :currentEmpresa="currentEmpresa"
           @newTitle="changeHomeTitle"
           @doPost="doPost "
          />
          <Edit
           v-if="editando"
            :currentUser="currentUser"
            :currentEmpresa="currentEmpresa"
            :currentPlanoConta="currentPlanoConta"
            @newTitle="changeHomeTitle"
            @doPut="doPut"
          />
        </div>
        <List v-if="isHide"
         :currentEmpresa="currentEmpresa"
         :listPlanoContas="listPlanoContas"
         :hide="isHide"
         @newTitle="changeHomeTitle"
         @edit="edit"
         @doDelete="doDelete"
        />
      </div>
    </div>
  </div>
</Layout>
</template>